// extracted by mini-css-extract-plugin
module.exports = {"description":"style__description__htx64","panelLink":"style__panelLink__xL-4U"};